import { defineComponent } from '~/scripts/utils/alpine'
import { useStore } from '~/scripts/composables/useStore'
import { useElementSize } from '~/scripts/composables/useElementSize'
import { scrollToAnchor } from '~/scripts/utils/scroll'

export default defineComponent(() => {
  return {
    init() {
      const store = useStore(this)
      useElementSize(this.$el, (size) => {
        store.ui.setHeaderHeight(size.height)
      })
    },
    onButtonClick(event: MouseEvent) {
      useStore(this).ui.setMenuVisible(false)
      scrollToAnchor(event.currentTarget as Element, event)
    },
  }
})
